import(/* webpackMode: "eager", webpackExports: ["ComingSoon"] */ "/app/apps/web/components/placeholder/coming-soon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamMatchSummary"] */ "/app/apps/web/components/tables/match-play/team-match-summary.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/cache/client-cache-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/config/client-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mascot"] */ "/app/packages/ui/components/mascot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatchplayLeaderboard"] */ "/app/packages/ui/components/table/leaderboard/matchplay-leaderboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StrokeplayLeaderboard"] */ "/app/packages/ui/components/table/leaderboard/strokeplay-leaderboard.tsx");
